import { Navigate, Outlet } from 'react-router-dom';
import { getAdminSession } from '@/features/admin/admin.storage';

export function RequireAdmin() {
  const session = getAdminSession();

  if (!session?.token) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
}
